import React from 'react';

export default function StationText() {
  return <div>Station text coming soon...</div>;
}
